import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'

import CenterContent from '../../widgets/components/CenterContent'
import createMeta from '../../utils/meta-creator'
import LiveChat from '../LiveChat'
import { setGlobalNumber } from '../../state/phone-number/actions'
import ContentBrandHero from '../ContentBrandHero'
import renderWidgets from '../../../lib/widget-renderer'
import OfferDefaultBody from './components/OfferDefaultBody'

class Offer extends React.PureComponent {
  componentDidMount() {
    this.props.setGlobalNumber({
      phoneNumber: this.props.calltracksNumber
    })
  }

  render() {
    const { offer, liveChatProviderId, locations } = this.props

    return (
      <div>
        <Helmet title={`${offer.heading}`} meta={createMeta(this.props)} />
        <LiveChat providerId={liveChatProviderId} />
        <ContentBrandHero
          title={offer.heading}
          bg={
            offer.promoImages && offer.promoImages.length > 0
              ? offer.promoImages[0]
              : null
          }
          img={offer.images && offer.images.length > 0 ? offer.images[0] : null}
          dark
        />

        {offer.body.length > 0 &&
          renderWidgets({
            widgets: offer.body,
            container: CenterContent,
            pageType: 'section',
            locations
          })}

        {offer.body.length === 0 && (
          <OfferDefaultBody offer={offer} locations={locations} />
        )}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  setGlobalNumber: (settings) => dispatch(setGlobalNumber(settings))
})

export default connect(null, mapDispatchToProps)(Offer)
